<template>
  <Drawer
    :visible="open"
    position="right"
    class="cockpit-ppc-drawer"
    :style="{ width: '480px' }"
    data-testid="cockpit-ppc-drawer"
    @update:visible="onVisible"
  >
    <template #header>
      <h3 class="text-[18px] font-semibold m-0">
        {{ $t('UserProjects.cockpit.drawer.title', { label: periodLabel }) }}
      </h3>
    </template>

    <div v-if="loading" class="text-sm text-[var(--color-disabled)] py-6">
      {{ $t('UserProjects.cockpit.loading') }}
    </div>

    <table v-else class="w-full">
      <thead>
        <tr class="border-b border-[#e5e5e5]">
          <th class="text-left text-[12px] font-medium text-[#ABABAB] uppercase tracking-wider pb-2">
            {{ $t('UserProjects.cockpit.drawer.name') }}
          </th>
          <th class="text-right text-[12px] font-medium text-[#ABABAB] uppercase tracking-wider pb-2">
            {{ $t('UserProjects.cockpit.drawer.commitments') }}
          </th>
          <th class="text-right text-[12px] font-medium text-[#ABABAB] uppercase tracking-wider pb-2">
            {{ $t('UserProjects.cockpit.drawer.done') }}
          </th>
          <th class="text-right text-[12px] font-medium text-[#ABABAB] uppercase tracking-wider pb-2">
            PPC
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="row in rows"
          :key="row.userId"
          class="border-b border-[#e5e5e5]"
          :style="{ opacity: row.inactive ? 0.4 : 1 }"
        >
          <td class="py-2.5 text-[13px]">
            {{ row.displayName }}
            <span
              v-if="row.inactive"
              class="ml-2 text-[10px] text-[#ABABAB]"
            >
              {{ $t('UserProjects.cockpit.drawer.inactive') }}
            </span>
          </td>
          <td class="py-2.5 text-[13px] text-right">{{ row.n }}</td>
          <td class="py-2.5 text-[13px] text-right">{{ row.doneCount }}</td>
          <td class="py-2.5 text-[13px] font-semibold text-right">
            {{ row.inactive || row.ppc === null ? '–' : `${row.ppc}%` }}
          </td>
        </tr>
      </tbody>
    </table>
  </Drawer>
</template>

<script>
import Drawer from 'primevue/drawer';

export default {
  name: 'CockpitPpcDetailDrawer',
  components: { Drawer },
  props: {
    open: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    breakdown: { type: Object, default: null },
  },
  emits: ['close'],
  computed: {
    rows() {
      return this.breakdown?.rows || [];
    },
    periodLabel() {
      return this.breakdown?.label || '';
    },
  },
  methods: {
    onVisible(visible) {
      if (!visible) this.$emit('close');
    },
  },
};
</script>
